import applyObservableCustomization from '@/Infrastructure/KnockoutCustomization/Observable';
import applyObservableArrayCustomization from '@/Infrastructure/KnockoutCustomization/ObservableArray';
import applyComputedCustomization from '@/Infrastructure/KnockoutCustomization/Computed';
import applyAsyncComputedCustomization from '@/Infrastructure/KnockoutCustomization/AsyncComputed';
import applyNumericObservableCustomization from '@/Infrastructure/KnockoutCustomization/NumericObservable';

export default function init() {
    applyObservableCustomization();
    applyObservableArrayCustomization();
    applyComputedCustomization();
    applyAsyncComputedCustomization();
    applyNumericObservableCustomization();
}